import { Play, Search, Server, Home, Scale } from "lucide-react";

const CASES = [
  {
    key: "data-centers",
    Icon: Server,
    label: "Case File · Infrastructure",
    title: "Data Centers",
    body: "Who pays for industrial-scale water, power, and air-quality costs when hyperscalers move in — and who signed the incentives.",
    video: "oUpnXs_HRb8",
  },
  {
    key: "housing",
    Icon: Home,
    label: "Case File · Housing",
    title: "Corporate Landlords",
    body: "Institutional buyers now own a growing share of single-family homes. We follow the deeds, the rents, and the lobbying.",
    video: "vCWTkT8zy4c",
  },
  {
    key: "accountability",
    Icon: Scale,
    label: "Case File · Governance",
    title: "Ballot Access & Gatekeeping",
    body: "Signature thresholds, party primaries, and media gatekeepers decide who gets heard. ATFQ puts the rule-makers on the record.",
    video: null,
  },
];

const CaseCard = ({ c }) => (
  <article data-testid={`investigation-${c.key}`} className="border-t border-slate-200 pt-6 flex flex-col">
    {c.video ? (
      <a
        href={`https://youtu.be/${c.video}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`investigation-${c.key}-video`}
        className="group relative block aspect-video overflow-hidden bg-slate-100 mb-5"
        aria-label={`Watch: ${c.title}`}
      >
        <img
          src={`https://img.youtube.com/vi/${c.video}/hqdefault.jpg`}
          alt=""
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-500"
        />
        <span className="absolute inset-0 flex items-center justify-center">
          <span className="w-12 h-12 bg-white/90 group-hover:bg-[var(--accent)] group-hover:text-white text-[#0A192F] flex items-center justify-center transition-colors">
            <Play className="w-5 h-5 fill-current" />
          </span>
        </span>
      </a>
    ) : (
      <div className="aspect-video bg-[#0A192F] mb-5 flex items-center justify-center">
        <c.Icon className="w-10 h-10 text-[var(--accent)]" />
      </div>
    )}
    <div className="text-xs tracking-tight text-[var(--accent)] mb-2">{c.label}</div>
    <h3 className="font-display text-2xl text-[#0A192F] leading-tight tracking-tight">{c.title}</h3>
    <p className="mt-2 text-sm text-slate-600 leading-relaxed">{c.body}</p>
  </article>
);

export const Investigations = () => (
  <section
    id="investigations"
    data-testid="investigations-section"
    className="bg-slate-50 border-y border-slate-200 py-20 md:py-28"
  >
    <div className="px-6 md:px-12 lg:px-20 max-w-[1400px] mx-auto">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <div className="max-w-2xl">
          <div className="text-xs tracking-tight text-[var(--accent)] mb-3 flex items-center gap-2">
            <Search className="w-3.5 h-3.5" /> Investigations
          </div>
          <h2 className="font-display text-4xl sm:text-5xl text-[#0A192F] leading-[0.95] tracking-tight">
            Open case files.
          </h2>
        </div>
        <a
          href="#atfq-ask"
          data-testid="investigations-tip-link"
          className="text-sm text-[var(--accent)] hover:text-[#0A192F] underline underline-offset-4 transition-colors"
        >
          Have a tip? Send it to the mic →
        </a>
      </div>
      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
        {CASES.map((c) => <CaseCard key={c.key} c={c} />)}
      </div>
    </div>
  </section>
);

export default Investigations;
